/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-01 10:23:11
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-05 09:51:08
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 列表
export const listDepart = params =>
  request(BASE_URL + '/govDepartment/listDepart', { params })

// 政务端-新增或更新部门数据
export const addOrUpdateDepart = params =>
  request.post(BASE_URL + '/govDepartment/addOrUpdateDepart', params)

// 政务端-更新部门基础信息
export const updateDepart = params =>
  request.post(BASE_URL + '/govDepartment/updateDepart', params)

// 政务端-政务端-刪除部门或科室
export const delDepart = params =>
  request(BASE_URL + '/govDepartment/delDepart', { params })

// 政务端-政务端-政务端-列表科员
export const listClerk = params =>
  request(BASE_URL + '/govDepartment/listClerk', { params })

// 政务端-政务端-政务端-新增或更新科员
export const saveOrUpdateClerk = params =>
  request.post(BASE_URL + '/govDepartment/saveOrUpdateClerk', params)

// 便企导航排序
export const sortNum = params =>
  request.post(BASE_URL + '/govDepartment/sortNum', params)
